/**
 * @author wuTao
 * @description
 * @Date 2020/12/25
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool} from '@/tool'
import 'antd/dist/antd.css';
import {Button} from 'antd';
import {WizTableForm} from '@/containers/common'
import moment from "moment";
import {string} from "prop-types";

const userConfig = WizTableForm.Config.user(this, {apiParams: {status: 1, roleConfig: "teacherNevRole"}});
let {WizContainer, modelUtils} = framework_tool;
let {WizForm, WizTimePicker, WizSelect, WizDatePicker, WizCol, WizRow,WizSpin,} = component_tool;
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

class BatchInput extends WizContainer {
  componentName = "BatchInput";

  constructor(props) {
    super(props);
    const {record, classAideEntityInfo} = props;
    const {classDate} = classAideEntityInfo;
    let classDateStart = classDate[0]; //
    let classDateEnd = classDate[1];

    //处理班级环节时间,以便带入认证设置
    let classAideDateStart = formatterDate(classAideEntityInfo.startTime);
    let classAideDateEnd = formatterDate(classAideEntityInfo.endTime);
    let classAideDate = null;
    let classAideStartTime = null;
    let classAideEndTime = null;

    if(classAideDateStart == classAideDateEnd){
        classAideDate = classAideDateStart;
        classAideStartTime = classAideEntityInfo.startTime
        classAideEndTime = classAideEntityInfo.endTime
    }

    this.state = {
      selectedRows: [],
      ids: [],
      id: record && record.id,
      authDate: record && record.authDate ? moment(record.authDate).format('YYYY-MM-DD') : classAideDate ,
      startDate: record && record.startDate ? formatterTime(record.startDate) : undefined,
      endDate: record && record.endDate ? formatterTime(record.endDate) : undefined,
      newStartDate: record && record.startDate ? formatterTime(record.startDate) : classAideStartTime ? formatterTime(classAideStartTime): undefined,
      newEndDate: record && record.endDate ? formatterTime(record.endDate) : classAideEndTime ? formatterTime(classAideEndTime): undefined,
      ownerId: record && record.ownerId,
      authChecking: false,
      record: record && record,
      formKey: new Date().getTime(),
      checkDateInfo : null
    };
    this.classDateStart = classDateStart;
    this.classDateEnd = classDateEnd;
    this.classAideEntityInfo = classAideEntityInfo;

    this.initTargetKeys = [];
    this.initTargetRows = [];
    this.values = {};
    this.classAideDate = classAideDate
    this.classAideStartTime = classAideStartTime
    this.classAideEndTime = classAideEndTime


  }

  _componentWillMount() {
    let {initRows} = this.props;
    if (initRows && initRows()) {
      this.state.selectedRows = initRows();
      this.initTargetRows = initRows();
      initRows().forEach(data => {
        let id = data.id ? data.id : data.id
        this.state.ids.push(id);
        this.initTargetKeys.push(id);
      })
    }
  }

  /**
   * 认证日期变更
   * @param date
   * @param dateString
   * @private
   */
  _changeAuthDate = (date, dateString) => {
    this.setState({
      authDate: dateString,
    })
    if(dateString && this.state.newStartDate && this.state.newEndDate){
      let startDateTimeStr = dateString + " " + this.state.newStartDate;
      let endDateTimeStr = dateString + " " + this.state.newEndDate;
      //this.verifyAuthTime(startDateTimeStr, endDateTimeStr, this.state.ownerId);
    }
  }

  /**
   * 禁用不能选择的日期
   * @param authValue
   * @returns {boolean}
   */
  disabledAuthDate = authValue => {
    let classDateStart = this.classDateStart;
    let classDateEnd = this.classDateEnd;
    if (!classDateStart || !classDateEnd) {
      return false;
    }
    let classDateStartStr = moment(classDateStart).format('YYYY-MM-DD') + ' 00:00:00';
    let classDateEndStr = moment(classDateEnd).format('YYYY-MM-DD') + ' 23:59:59';
    return authValue.valueOf() > moment(classDateEndStr).valueOf() || authValue.valueOf() < moment(classDateStartStr).valueOf();
  };

  getSelectRows = (e) => {
    this.state.selectedRows = e;
    this.initTargetRows = e;
    this.state.ids = [];
    e.forEach(data => {
      this.state.ids.push(data.id);
      this.initTargetKeys.push(data.id);
    })
  };

  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = () => {
    const {authDate} = this.state;
    this.formData.validateFields((err, values) => {
      let value = Object.assign([], values);
      if (value['startDate']){
        let startDate = moment(authDate + ' ' + formatterTime(value['startDate'])).format('YYYY-MM-DD HH:mm:ss')
        value.startDate = startDate;
      }
      if (value['endDate']){
        let endDate = moment(authDate + ' ' + formatterTime(value['endDate'])).format('YYYY-MM-DD HH:mm:ss')
        value.endDate = endDate
      }
      if (value['authDate']){
        let authDate = value['authDate'].format('YYYY-MM-DD HH:mm:ss')
        value.authDate = authDate
      }
      if ( this.props.alone){
        let lectureId = value['lectureId'];
        value.lectureIdList=[lectureId];
      }
      value.remoteAuthId= this.props.entityId;
      value.classAideId= this.props.classAideId;
      if (this.state.ids.length === 0 && !this.props.alone) {
        wizNotice.error("请选择学员");
      } else if (!err) {
        if (this.props.alone && this.props.alone){
          value.ids=[this.props.record.id ? this.props.record.id : this.props.record.id]
        }
        this.values = value;

        let classDateStartTime = new Date(this.classDateStart).getTime() // 环节时间
        let classDateEndTime = new Date(this.classDateEnd).getTime() // 环节时间
        let startDateTime = new Date(value.startDate).getTime() // 认证时间
        let endDateTime = new Date(value.endDate).getTime() // 认证时间
        if( startDateTime > endDateTime){
          wizNotice.error("认证结束时间不可早于开始时间,请确认后重试!");
        }else if(startDateTime<=endDateTime && (endDateTime-startDateTime)<300000){
          wizNotice.error("认证时间间隔不可少于5分钟,请确认后重试!");
        }else if(classDateStartTime>startDateTime){
          wizNotice.error("认证开始时间不可早于环节开始时间,请确认后重试!");
        }else if(classDateEndTime && classDateEndTime<endDateTime){ // 环节结束时间可能为null
          wizNotice.error("认证结束时间不可晚于环节结束时间,请确认后重试!");
        }else{
          this._saveRemoteAuth(value);
        }

      }
      return
    });
  };

  /**
   * 初始化已选人员
   */
  _doInitParams = () => {
    this.formData.resetFields();
    this.onChange(this.initTargetKeys, this.initTargetRows)
    this.refreshList();
  };

  onChange = (nextTargetKeys, nextTargetRows) => {
    this.setState({
      ids: nextTargetKeys,
      selectedRows: nextTargetRows,
      checkDateInfo : null
    });
  };

  propsAndStateOnChange = {
    batchConfigNevRemoteAuthDetail: this._batchConfigNevRemoteAuthDetail.bind(this),
    checkMeetingDate : this._checkMeetingDateOver.bind(this),
  };

  _batchConfigNevRemoteAuthDetail(nextProps, nextState) {
    nextState.checkDateInfo = null;
    console.log("nextProps==",nextProps);
    if (nextProps.batchConfigNevRemoteAuthDetail.code === 1) {
      wizNotice.success("操作成功");
      this.onChange(this.initTargetKeys, this.initTargetRows);
      this.refreshList();
    } else {
      wizNotice.error(nextProps.batchConfigNevRemoteAuthDetail.msg);
    }
  }

  _checkMeetingDateOver(nextProps, nextState) {
    if (nextProps.checkMeetingDate.code == 1) {
      nextState.checkDateInfo = nextProps.checkMeetingDate.data
    }
    return true;
  }

  /**
   * 更新原列表
   */
  refreshList() {
    let {changeModal} = this.props;
    changeModal && changeModal(false, true)
  }

  /**
   * 更新 班级学员远程认证信息
   * @param values
   * @private
   */
  _saveRemoteAuth(values) {
    let apiPath = "NevRemoteAuthDetail/batchConfigNevRemoteAuthDetail";
    let payloadKey = "NevRemoteAuthDetail@batchConfigNevRemoteAuthDetail"; //batchUpdateStudentRemoteAuth
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...values,
        }
      }
    });
  }

  handleClear(id) {
    id
      ? this.setState({
        selectedRows: this.state.selectedRows.filter(item => item.id !== id),
        ids: this.state.ids.filter(item => item !== id)
      })
      : this.setState({
        selectedRows: [],
        ids: []
      });
  }

  //select中的change事件
  _wizSelectOnChange(value, option) {
    let classify = value.map(select => select.key)
    let selectedRows = this.state.selectedRows.filter(filter => classify.indexOf(filter.key) !== -1)
    const selectIds = [];
    selectedRows.forEach(data => {
      selectIds.push(data.id)
    })
    this.setState({
      selectedRows: selectedRows,
      ids: selectIds
    });
  }

  _renderOptions(selectedRows) {
    if (selectedRows && selectedRows.length) {
      return selectedRows.map((row, i) => this._renderOption(row))
    }
    return null
  }

  _renderOption(row) {
    if (row) {
      const fullName = row.fullName;
      return (
        <WizSelect.Option key={row.id} value={fullName} title={fullName}>
          {fullName}
        </WizSelect.Option>
      )
    }
  }

  /**直播选择讲师 */
  renderLecturerValue(value, valueRows) {
    return (
      <div>  {valueRows && valueRows[0] && valueRows[0].userName ? valueRows[0].userName : ''}</div>
    )
  }

  /**
   * 更新时间
   * @param time
   * @param timeString
   * @param type 0 开始时间；1 结束数据
   */
  onChangeTime = (time, timeString, type) => {
    let newStartDate = this.state.newStartDate;
    let newEndDate = this.state.newEndDate;
    if (type === 0) { //开始
      if (time === null || time === '') {
        newStartDate = null;
      } else {
        newStartDate = timeString;
      }
    }
    if (type === 1) { //结束
      if (time === null || time === '') {
        newEndDate = null;
      } else {
        newEndDate = timeString;
      }
    }
    const {startDate, endDate, ownerId, authChecking, authDate} = this.state;
    this.checkAuthTimes(startDate, endDate, newStartDate, newEndDate, ownerId, authChecking, authDate);
  }

  /**
   * 校验认证时间是否有资源 先校验数据
   * @private
   */
  checkAuthTimes(startDate, endDate, newStartDate, newEndDate, ownerId, authChecking, authDate) {
    this.setState({
      newStartDate,
      newEndDate,
      startDate: newStartDate,
      endDate: newEndDate,
    });
    if (!authChecking && newStartDate != null && newStartDate != '' && newEndDate != null && newEndDate != '') {
      if (startDate === null || endDate === null || newStartDate != startDate || newEndDate != endDate) {
        let startDateTimeStr = authDate + " " + newStartDate;
        let endDateTimeStr = authDate + " " + newEndDate;
        let newStartDateTime = moment(startDateTimeStr);
        let newEndDateTime = moment(endDateTimeStr);
        if (newStartDateTime && newEndDateTime && (moment(newEndDateTime).isBefore(newStartDateTime) ||
          moment(newEndDateTime).diff(newStartDateTime) < 60000)) {
          return;
        }
        if(authDate && newStartDate && newEndDate){
          //this.verifyAuthTime(startDateTimeStr, endDateTimeStr, ownerId);
        }
      }
    }
  }

  // /**
  //  * 认证开始时间选择校验
  //  * @param rule
  //  * @param value
  //  * @param callback
  //  */
  // validateStartDate = (rule, value, callback) => {
  //   if (!value) {
  //     callback('请选择认证开始时间');
  //     return;
  //   }
  //   let classDateStart = this.classDateStart;
  //   let classDateEnd = this.classDateEnd;
  //   const {authDate} = this.state;
  //   // if (!authDate) {
  //   //   callback('请先选择认证日期');
  //   //   return;
  //   // }
  //   let newStartDateTime = moment(authDate + ' ' + formatterTime(value));
  //   if (moment(classDateStart).valueOf() > newStartDateTime.valueOf()) {
  //     callback('认证开始时间不能小于环节开始时间');
  //     return;
  //   }
  //   if (moment(classDateEnd).valueOf() < newStartDateTime.valueOf()) {
  //     callback('认证开始时间不能大于环节结束时间');
  //     return;
  //   }
  //   callback();
  // }

  // /**
  //  * 认证结束时间选择校验
  //  * @param rule
  //  * @param value
  //  * @param callback
  //  */
  // validateEndDate = (rule, value, callback) => {
  //   if (!value) {
  //     callback('请选择认证结束时间');
  //     return;
  //   }
  //   let classDateEnd = this.classDateEnd;
  //   let startDate = this.formData.getFieldValue('startDate');
  //   const {authDate} = this.state;
  //   // if (!authDate) {
  //   //   callback('请先选择认证日期');
  //   //   return;
  //   // }
  //   if (!startDate) {
  //     callback('请先选择认证开始时间');
  //     return;
  //   }
  //   let newStartDateTime = moment(authDate + ' ' + formatterTime(startDate));
  //   let newEndDateTime = moment(authDate + ' ' + formatterTime(value));
  //   if (newStartDateTime && newEndDateTime && newEndDateTime.valueOf()<newStartDateTime.valueOf()) {
  //     callback('认证结束时间不能小于认证开始时间');
  //     return;
  //   }
  //   if (moment(newEndDateTime).diff(newStartDateTime) < 60000) {
  //     callback('认证结束时间与认证开始时间间隔不能小于1分钟');
  //     return;
  //   }
  //   if (moment(classDateEnd).valueOf() < newEndDateTime.valueOf()) {
  //     callback('认证结束时间不能大于环节结束时间');
  //     return;
  //   }
  //   callback();
  // }


  /**
   * 校验认证时间是否有资源
   * @private
   */
  verifyAuthTime(startDate, endDate, ownerId) {
    let {id} = this.state;
    if (!startDate || !endDate) {
      return;
    }
    this.setState({
      authChecking: true
    })
  //  this.checkMeetingDate(startDate, endDate, ownerId,2);
  }

  /**校验对应时间段是否有直播资源 xyguo 3-27  0:zoom资源帐户；1：中目资源帐户 */
  checkMeetingDate(startDate, endDate,meetingNo,type) {
    this.doAction({
      path: 'interactLive/checkMeetingDate',
      payload: {
        key: 'interactLive@checkMeetingDate',
        apiParams: {
          startDate,
          endDate,
          meetingNo,
          type
        }
      }
    });
  }

  _render() {
    const {record,studentRemoteAuthDetailLoading,NevRemoteAuthDetailLoading} = this.props;
    const ids = this.state.ids;
    let checkDateInfo = this.state.checkDateInfo;
    let personInfo = [];
    if (record && record.lectureId && (record.lectureFullName || record.lectureName )){
      let lectureName = record.lectureFullName ? record.lectureFullName : record.lectureName;
      personInfo = [{key:'1',personId:record.lectureId, fullName:lectureName ,id:record.lectureId}]
    }
    let columns = [
      {
        name: "ids",
        formItem: {
          type: 'hidden',
          initialValue: ids
        },
      },
      this.props.alone ?
        {
          title: "账号",
          name: "userName",
          formItem: {
            initialValue: record.userName,
            disabled: true
          }
        }
        : {},
      this.props.alone ? {
          title: "姓名",
          name: "fullName",
          formItem: {
            initialValue: record.fullName,
            disabled: true
          }
        }
        : {},
      this.props.alone ?
        {
          title: "讲师",
          name: "lectureId",
          formItem: {
            ...userConfig,
            diy: WizTableForm,
            initialValue: record.lectureId!=null ? record.lectureId : '',
            initRows: personInfo,
            selectType: 'radio',
            rules: [{required: true, message: '请选择讲师'}],
          },
        }
         : {
          title: "讲师",
          name: "lectureIdList",
          formItem: {
            ...userConfig,
            diy: WizTableForm,
            initialValue: [],
            initRows: [],
            selectType: 'checkbox',
            renderValue: undefined,
            rules: [{required: true, message: '请选择讲师'}],
          },
        },
      {
        title: "认证日期",
        formItem: {
          type: 'custom',
          render: (data, form) => {
            const {getFieldDecorator} = form;
            return (
              <div>
                {
                  getFieldDecorator('authDate', {
                    rules: [{required: true, message: '请选择认证日期',}],
                    initialValue: record && record.authDate ? moment(record && record.authDate) : this.classAideDate ? moment(this.classAideDate): undefined
                  })(
                    <WizDatePicker key='authDate'
                                   format="YYYY-MM-DD"
                                   disabledDate={this.disabledAuthDate}
                                   placeholder={'请选择认证日期'}
                                   onChange={this._changeAuthDate}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      {
        title: '认证时间',
        formItem: {
          type: 'custom',
          col: { span: 14 },
          formItemLayout: {
            labelCol: {span: 7},
            wrapperCol: {span: 17}
          },
          render: (data, form) => {
            const {getFieldDecorator} = form;
            return (
              <WizRow className={'credit-subject-row-item'}>
                <WizCol span={24}>
                  {
                    getFieldDecorator('startDate', {
                      rules: [{required: true,message:"认证开始时间不可为空"}],
                      initialValue: record && record['startDate'] ? moment(record['startDate']) : this.classAideStartTime ? moment(this.classAideStartTime) : undefined
                    })(
                      <WizTimePicker placeholder={'请选择认证开始时间'}
                                     onChange={(time, timeString) => {
                                       this.onChangeTime(time, timeString, 0)
                                     }}

                      />
                    )
                  }
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '',
        formItem: {
          type: 'custom',
          col: { span: 10 },
          formItemLayout: {
            labelCol: {span: 0},
            wrapperCol: {span: 24}
          },
          render: (data, form) => {
            const {getFieldDecorator} = form;
            return (
              <WizRow className={'credit-subject-row-item'}>
                <WizCol className='col-item-center' span={3}>至</WizCol>
                <WizCol span={21}>
                  {
                    getFieldDecorator('endDate', {
                      rules: [{required: true,message:"认证结束时间不可为空"}],
                      initialValue: record && record['endDate'] ? moment(record['endDate']) : this.classAideEndTime ? moment(this.classAideEndTime) : undefined
                    })(
                      <WizTimePicker
                        placeholder={'请选择认证结束时间'}
                        onChange={(time, timeString) => {
                          this.onChangeTime(time, timeString, 1)
                        }}
                      />
                    )
                  }
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      // {
      //   title: <font style={{'color': 'red'}}>提醒</font>,
      //   name: "notice",
      //   formItem: {
      //     type : 'diy',
      //     diy: () => {
      //       return (
      //           <div style={{'color': 'red'}}>{'可设置认证时间为' + moment(this.classDateStart).format('YYYY.MM.DD HH:mm:ss') + ' ~ ' + (this.classDateEnd ? moment(this.classDateEnd).format('YYYY.MM.DD HH:mm:ss'):"")} </div>
      //       )
      //     }
      //   }
      // },
      // this.state.checkDateInfo?
      // {
      //   title: <font style={{'color': 'red'}}>剩余资源</font>,
      //   name: "checkDateInfo",
      //   formItem: {
      //     type: this.state.checkDateInfo ? 'diy' : 'hidden',
      //     diy: () => {
      //         return (
      //             <div style={{'color': 'red'}}>{this.state.checkDateInfo}</div>
      //         )
      //     }
      //   },
      // }:{},
    ];
    let onSubmit = this._saveRemoteAuth.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: <div/>,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 20}
      },
      style: {maxWidth: 800}
    };
    let selectKey = this.state.selectedRows.map(selected => selected.id).join(",");
    const selectedRows = this.state.selectedRows;
    selectedRows.forEach(data => {
      data.key = data.id;
      data.label = data.fullName
    });
    const header = (
      <div style={{paddingLeft: 15, paddingBottom: 12}}>
        已选人员<strong> {selectedRows.length} </strong> {'人'}
        <Button type="link" onClick={() => this.handleClear()}>清除选择</Button>
      </div>
    );

    return (
      <WizSpin tip={"加载中"} spinning={NevRemoteAuthDetailLoading}>
      <div>
        {!this.props.alone ? <>{header} <WizSelect
          style={{width: '100%', height: 80, paddingLeft: 15}}
          key={'wizSelect_' + selectKey}
          defaultValue={this.state.selectedRows}
          labelInValue
          mode={'multiple'}
          open={false}
          onChange={(value, option) => this._wizSelectOnChange(value, option)}
        >
          {this._renderOptions(selectedRows)}
        </WizSelect></> : <></>}
        <WizForm  {...formProps} ref={r => {
          this.formData = r;
        }}/>
      </div>
      </WizSpin>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  const {studentRemoteAuthDetail,interactLive,NevRemoteAuthDetail} = state;
  const batchConfigNevRemoteAuthDetail = modelUtils.getModelEntity(NevRemoteAuthDetail, 'NevRemoteAuthDetail@batchConfigNevRemoteAuthDetail');
  const checkMeetingDate = modelUtils.getModelEntity(interactLive, "interactLive@checkMeetingDate");
  const load = modelUtils.getLoadingState(state, ['studentRemoteAuthDetail','NevRemoteAuthDetail']);
  return {
    batchConfigNevRemoteAuthDetail: batchConfigNevRemoteAuthDetail,
    checkMeetingDate,
    ...load
  };
};

const options = {withRef: true};

export default connect(mapStateToProps, null, null, options)(BatchInput);
